module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-title"
  }, [_c('span', {
    staticClass: "title-kh-1"
  }, [_vm._v("》")]), _c('span', {
    staticClass: "title-kh-2"
  }, [_vm._v("》")]), _c('span', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f5f9bc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/ContentTitle.vue
// module id = 784
// module chunks = 1